/**
 * 描述：水印管理界面
 * 日期：2020-10-27
 * 作者：tanyaohua
 */
angular.module('productManageMentTheWatermarkMgrModule', [])
    .controller('productManageMentTheWatermarkMgr', ['productManageMentService', 'trsHttpService', 'modalDialog', 'trsspliceString', '$state', '$scope', 'editingMediatype',
        function(productManageMentService, trsHttpService, modalDialog, trsspliceString, $state, $scope, editingMediatype) {
            initStatus();
            initData();
        

            /**
             * [initStatus description]初始化状态
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.page = {
                    'CURRPAGE': 1,
                    'PAGESIZE': 20
                };
                // $scope.status = {

                // };
                $scope.data = {
                    items: []
                };

                $scope.status = {
                    watermarkTitle: $state.params.name,
                    // 就获得了是什么渠道
                    mediaType: editingMediatype[$state.params.type],
                };
                $scope.params = {
                    'serviceid': 'mlf_watermark',
                    'methodname': 'queryWaterMarksNew',
                    'productId': $state.params.site,
                    'mediaType': $scope.status.mediaType,
                    'CurrPage': $scope.page.CURRPAGE,
                    'PageSize': $scope.page.PAGESIZE,
                    // 'LIBID': $stateParams.site
                };
            }

            /**
             * [initData description]初始化方法
             *
             * @return  {[type]}  [return description]
             */
            function initData() {
                dropList();
                requestData();
            }
            
            /**
             * [selectAll description]全选
             * @return {[type]} [description] null
             */
            $scope.selectAll = function() {
                $scope.data.selectedArray = $scope.data.selectedArray.length === $scope.data.items.length ? [] : []
                    .concat($scope.data.items);
            };

            /**
             * [selectDoc description]单选
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.selectDoc = function(item) {
                var index = $scope.data.selectedArray.indexOf(item);
                if (index < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice(index, 1);
                }
            };

            /**
             * [pageChanged description]翻页
             * @return {[type]} [description] null
             */
            $scope.pageChanged = function() {
                // $scope.status.params.CURRPAGE = $scope.page.CURRPAGE;
                $scope.params.CURRPAGE = $scope.page.CURRPAGE;
                $scope.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };

            /**
             * [jumpToPage description]到指定页
             * @return {[type]} [description] null
             */
            $scope.jumpToPage = function() {
                if ($scope.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.copyCurrPage = $scope.page.PAGECOUNT;
                }
                // $scope.status.params.CURRPAGE = $scope.copyCurrPage;
                $scope.params.CURRPAGE = $scope.copyCurrPage;
                $scope.page.CURRPAGE = $scope.copyCurrPage;
                requestData();
            };

            /**
             * [selectPageNum description]单页选择页数
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function() {
                $scope.params.CURRPAGE = $scope.page.CURRPAGE = 1;
                $scope.params.PAGESIZE = $scope.page.PAGESIZE;
                $scope.copyCurrPage = 1;
                requestData();
            };

            /**
             * [selectStatus description]根据状态筛选水印
             * @params [{}] [description]
             * @return null [description]
             */

            $scope.selectStatus = function() {
                $scope.params.STATUS = $scope.status.selectStatus.value;
                requestData();
            };


            /**
             * [visualizeNew description]新建水印
             * @return {[type]} [description] null
             */
            $scope.createWatermark = function() {
                $scope.loadingPromise = productManageMentService.createWatermark({mediaType: $scope.status.mediaType}).then(function(data) {
                    requestData();
                });
            };


            /**
             * [deleteTemplate description]批量删除水印
             * @return {[type]} [description] null
             */
            $scope.deleteTemplate = function() {
                modalDialog.confirmModal('删除', '确定删除？', function() {
                    var params = {
                        serviceid: 'mlf_watermark',
                        methodname: 'deleteWaterMarkNew',
                        productId: $state.params.site,
                        ObjectIds: trsspliceString.spliceString($scope.data.selectedArray,
                            'WATERMARKID', ','),
                        mediaType: $scope.status.mediaType,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                        .then(function(data) {
                            modalDialog.alertType('删除成功', '', 'success', false);
                            requestData();
                        });
                });
            };

            // 删除操作

            $scope.deleteViews = function(websiteItem) {
                modalDialog.confirmModal('删除', '确定删除？', function() {
                    var delParams = {
                        serviceid: 'mlf_watermark',
                        methodname: 'deleteWaterMarkNew',
                        productId: $state.params.site,
                        mediaType: $scope.status.mediaType,
                        ObjectIds: websiteItem.WATERMARKID,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), delParams, 'post')
                        .then(function(data) {
                            modalDialog.alertType('删除成功', '', 'success', false);
                            requestData();
                        });
                });
            };

            /**
             * [enableDisable description]启用停用水印
             *
             * @param   {[type]}  websiteItem  [websiteItem description]
             *
             * @return  {[type]}               [return description]
             */
            $scope.enableDisable = function(websiteItem) {
                if (websiteItem.STATUS === '0') {
                    modalDialog.confirmModal('提示信息', '确定停用？', function() {
                        $scope.disableSite(websiteItem, '-1');
                    });

                } else {
                    modalDialog.confirmModal('提示信息', '确定启用？', function() {
                        $scope.disableSite(websiteItem, '0');
                    });

                }
            };


            $scope.disableSite = function(websiteItem, type) {
                var checkParams = {
                    serviceid: 'mlf_watermark',
                    methodname: 'restoreWatermark',
                    ObjectId: websiteItem.WATERMARKID,
                    Status: type,
                    LibId: $state.params.site
                };
                var alertText = type === 0 ? '启用成功' : '停用成功';
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), checkParams, 'post')
                    .then(function(data) {
                        modalDialog.alertType(alertText, '', 'success', false);
                        requestData();
                    });
            };

            /**
             * [requestData description]刷列表
             *
             * @return  {[type]}  [return description]
             */
            function requestData() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                    $scope.data.items = data.DATA;
                    $scope.page = data.PAGER ? data.PAGER : $scope.page;
                    $scope.data.selectedArray = [];
                });
            }

            /**
             * [dropList description] 初始化水印管理
             *
             * @return  {[type]}  [return description]
             */
            function dropList() {
                // 初始化水印类型
                $scope.status.statusOptions = [{
                    name: '全部状态',
                    value: '',
                }, {
                    name: '启用',
                    value: 0,
                }, {
                    name: '停用',
                    value: -1
                }];
                        
                $scope.status.selectStatus = $scope.status.statusOptions[0];
            }

            /**
             * [handlePic description] 处理小图片
             * @param  {[type]} item [description] 处理项
             * @return {[type]}      [description]
             */
            $scope.handlePic = function(item) {
                if (item.PICSRC) {
                    item.ALLIMG = [{
                        PICSLOGO: item.PICSRC,
                    }];
                    item.METALOGOURL = { PICSLOGO: item.PICSRC, PICSLOGO2: item.PICSRC };
                }
            };

            /**
             * [backGo description]返回列表
             *
             * @return  {[type]}  [return description]
             */
            $scope.backGo = function () {
                var router = 'manageconfig.productmanage.' + $state.params.type;
                $state.go(router, {}, { reload: router });
            };
        }]);
